import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';

export const DictionarySearchSection = () => {
  const navigate = useNavigate();
  const [searchKeyword, setSearchKeyword] = useState<string>('');

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (searchKeyword) {
      navigate(`/dictionary/machines?searchTerm=${searchKeyword}`);
    }
  };

  return (
    <SearchSection>
      <SearchSectionTitle>{'찾고 있는 모델을 검색 해보세요'}</SearchSectionTitle>
      <SearchForm
        onSubmit={(e) => {
          handleSearch(e);
        }}
      >
        <SearchInput
          type={'text'}
          id={'keyword'}
          placeholder={'검색'}
          value={searchKeyword}
          onChange={(e) => setSearchKeyword(e.target.value)}
        />
        <SearchButton type={'submit'}>
          <Icon name={'Search2'} width={16} height={16} />
        </SearchButton>
      </SearchForm>
      <SearchProductPromoSection>
        {/* TODO : tagId 값을 UUID로 변경 또는 tagName 기반으로 검색하도록 기능 변경 */}
        <SearchChip onClick={() => navigate('/dictionary/machines?tagId=BRAND:JOHNDEERE')}>{'존디어'}</SearchChip>
        <SearchChip onClick={() => navigate('/dictionary/machines?tagId=BRAND:YANMAR')}>{'얀마'}</SearchChip>
        <SearchChip onClick={() => navigate('/dictionary/machines?searchTerm=Y5113')}>{'Y5113'}</SearchChip>
      </SearchProductPromoSection>
    </SearchSection>
  );
};

const SearchSection = styled.div`
  width: 100%;

  margin-top: 24px;

  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 16px;

  padding: 40px 0px;

  background-color: #f3f4f5;
`;

const SearchSectionTitle = styled.h3`
  color: #232429;

  font-size: 14px;
  font-weight: 500;
  line-height: 100%;
`;

const SearchForm = styled.form`
  height: 36px;

  padding: 4px 4px 4px 16px;

  border-radius: 50px;

  display: flex;
  justify-content: flex-end;
  align-items: center;

  background-color: #fff;

  gap: 4px;
`;

const SearchInput = styled.input`
  width: 32px;

  padding: 0px;

  background-color: #fff;
  font-weight: 500;
  line-height: 100%;
  font-size: 12px;

  border: none;
  outline: none;

  &::placeholder {
    color: #aeafb6;
    font-weight: 500;
    line-height: 100%;
    font-size: 12px;
  }

  :focus {
    width: 100px;
    outline-offset: 0px;
    --tw-ring-shadow: none;
  }
`;

const SearchButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 28px;
  min-height: 28px;
  padding: 6px;

  border-radius: 50px;

  background-color: #dcdde0;

  cursor: pointer;
`;

const SearchProductPromoSection = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
`;

const SearchChip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 4px 12px;

  border-radius: 50px;

  background-color: #dcdde0;

  color: #505363;
  font-size: 12px;
  line-height: 100%;

  cursor: pointer;
`;
